import { Injectable, inject, computed } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { from } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class MarkdownService {
  #sanitizer = inject(DomSanitizer);

  render(markdown: string) {
    const dirtyHtml = toSignal(from(marked.parse(markdown ?? '')));
    return computed(() => {
      const html = dirtyHtml();

      if (!html) return <SafeHtml>'';

      return this.#sanitizer.bypassSecurityTrustHtml(DOMPurify.sanitize(html));
    });
  }
}
